export const cars =[
    {
        image: "/images/Nissan_micra/pirveli.webp",
        // title: "Nissan Micra"
    },
    {
        image: "/images/Nissan_micra/meore.webp",
        // title: "Nissan Micra"
    },
    {
        image: "/images/Nissan_micra/mesame.webp",
        // title: "Nissan Micra"
    }
    
    // ,
    // {
    //     image: "/images/image-unavailable.webp",
    //     title: "Nissan Micra"
    // },
    // {
    //     image: "/images/daster.jpg",
    //     title: "Nissan Micra"
    // }
];